<div class="cosmos-credential-modal__form">
  <form [formGroup]="_credentialForm">
    <div class="cosmos-credential-modal__form__field">
      <mat-form-field>
        <mat-label>User ID</mat-label>
        <input
          matInput
          formControlName="userId"
          label="Identifier"
          type="number"
        >
      </mat-form-field>
    </div>
    <div class="cosmos-credential-modal__form__field">
      <mat-form-field>
        <mat-label>Password</mat-label>
        <input
          matInput
          formControlName="password"
          label="Password"
          type="password"
        >
      </mat-form-field>
    </div>
  </form>
</div>
<div class="cosmos-credential-modal__buttons">
  <button
    [disabled]="!_credentialForm.valid"
    (click)="verifyCredentials()"
    type="button"
    class="cosmos-credential-modal__buttons__addButton"
  >
    Verify
  </button>
  <button
    (click)="closeModal()"
    class="cosmos-credential-modal__buttons__cancelButton"
  >
    Cancel
  </button>
</div>
